// Helper to generate default props for Vuetify components
const withPrimaryColorAndUnderline = (components) =>
  Object.fromEntries(components.map((name) => [name, { color: 'primary', variant: 'underlined' }]));

export default {
  ...withPrimaryColorAndUnderline(['VCheckbox', 'VCheckboxBtn', 'VTextField', 'VSelect', 'VAutocomplete']),
  VTextarea: { color: 'primary', variant: 'outlined' },
  VTabs: { color: 'primary' },
  VTab: { style: { fontSize: '15px' } },
  VCombobox: { variant: 'underlined' },
  VRadioGroup: { color: 'primary' },
  VSwitch: { color: 'primary' },
  VProgressLinear: { color: 'primary' },
};
